import { render, staticRenderFns } from "./ApeTable.vue?vue&type=template&id=cd38c790&scoped=true"
import script from "./ApeTable.vue?vue&type=script&lang=js"
export * from "./ApeTable.vue?vue&type=script&lang=js"
import style0 from "./ApeTable.vue?vue&type=style&index=0&id=cd38c790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd38c790",
  null
  
)

export default component.exports